<script setup lang="ts">
import BackendError from '~/components/layout/errors/BackendError.vue';
import Header from '~/components/layout/registration/Header.vue';
import Footer from '~/components/layout/Footer.vue';
import CookiesAgreementBanner from '~/components/layout/CookiesAgreementBanner.vue';

provide('theme', 'light');

onMounted(() => {
  document.body.classList.add('light');
  document.body.classList.remove('dark');

  document.body.classList.add('internal');
  document.body.classList.remove('external');
});
</script>

<template>
  <ClientOnly>
    <BackendError />

    <Header />

    <main id="main">
      <NuxtPage />
    </main>

    <Footer />

    <CookiesAgreementBanner />
  </ClientOnly>
</template>

<style lang="scss" scoped>
main {
  min-height: calc(100vh - var(--menu-clearfix-height));
}
</style>
